import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import DeleteInBatchByIdEditing from './deleteinbatchbyidediting';

export default class DeleteInBatchById extends Plugin {
  static get pluginName() {
    return 'DeleteInBatchById';
  }

  static get requires() {
    return [ DeleteInBatchByIdEditing ];
  }
}
